import { render, staticRenderFns } from "./jobDetail.vue?vue&type=template&id=439ccc97&scoped=true"
import script from "./jobDetail.vue?vue&type=script&lang=js"
export * from "./jobDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439ccc97",
  null
  
)

export default component.exports